import type { FC } from 'react';

import { StationType } from 'pages/Map/types';

import { BigJuncture } from './BigJuncture';
import { Completion } from './Completion';
import { Decision } from './Decision';
import { Info } from './Info';
import { SubZone } from './SubZone';
import { Transition } from './Transition';
import { ZoneStart } from './ZoneStart';
import colors from 'theme/colors';

const StationIconSizeStyle = {
    width: '100%',
    height: '100%'
};

/**
 * Definition of each type can be found at https://github.com/mantacares/planner/blob/main/docs/design/maps.md#types
 */
export const StationIcon: FC<{ type: StationType; isHighlight?: boolean; background?: string }> = ({ type, isHighlight, background }) => {
    const StationIconStyle = {
        ...StationIconSizeStyle,
        background: background ? background : isHighlight ? colors.coral[500] : undefined,
        color: isHighlight ? colors.black : undefined
    };

    switch (type) {
        case StationType.ZoneStart:
            return <ZoneStart {...StationIconStyle} />;
        case StationType.Decision:
            return <Decision {...StationIconStyle} />;
        case StationType.Info:
            return <Info {...StationIconStyle} />;
        case StationType.SubZone:
            return <SubZone {...StationIconStyle} />;
        case StationType.Transition:
            return <Transition {...StationIconStyle} />;
        case StationType.ZoneEnd:
            return <Completion {...StationIconStyle} />;
        case StationType.BigJuncture:
            return <BigJuncture {...StationIconStyle} />;
        default:
            return <></>;
    }
};
